// import Orientation from 'react-native-orientation-locker';
import { IAdaptiveActionCard } from '@ninjacart/nc-nk-core';
import {
  INinjaEvent,
  addEventParam,
  useEventStore,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import {
  FallBackImage,
  IRemoteVideoMetadata,
  ROUTES,
  getPlayListItem,
  getSeoUrl,
  getStreamURI,
  getThredsApi,
  getVideoComments,
  getVideoDetails,
  isInvalidPostOwnerId,
  msToTime,
  onVideoLike,
  transformFeedComment,
  transformStreamComment,
  truncateName,
  updateFollowStatusApi,
  updateLikedStream,
  updateVideoStreamPlayback,
  useAppPersistenceStore,
  useEventZStore,
  useFeedStore,
  useProfileStore,
  useGlobalLoginContext,
  KissanEventType,
  handleMarketingEvents,
} from '@ninjacart/nc-nk-store';
import {
  Avatar,
  Card,
  CommentSection,
  Content,
  FollowButton,
  Image,
  LikeRegular,
  LikeSolidRegular,
  Paragraph,
  Separator,
  ShareRegular,
  Stack,
  Text,
  UIBottomSheet,
  VideoPlayIconRegular,
  View,
  XStack,
  YStack,
  useToastController,
} from '@ninjacart/nc-nk-ui';
import {
  BannerAds,
  handleContactPermission,
  useNavigation,
  useRouter,
} from '@ninjacart/nc-nk-web-deps';
import { FlashList } from '@shopify/flash-list';
import { Eye, MessageCircle } from '@tamagui/lucide-icons';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Alert,
  Appearance,
  BackHandler,
  Dimensions,
  Platform,
  Pressable,
  Share,
  StatusBar,
  StyleProp,
  ViewStyle,
} from 'react-native';
import { getVersion } from 'react-native-device-info';
import Orientation, { OrientationType } from 'react-native-orientation-locker';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Placeholder, PlaceholderLine, PlaceholderMedia, Shine } from 'rn-placeholder';
import { useParams } from 'solito/navigation';
import { LinearGradient } from 'tamagui/linear-gradient';
import NKPlayer from '../components/nKPlayer';
import { NKConfig, NKPlayerRef, NKSource, PlayList, PlayListItem } from '../types/nkPlayerTypes';
import { OnProgressDataWithItemKey } from '../types/nkPlayerTypes';
import { transformToPlaylistItem } from '../utils/transformToPlaylist';

interface NKVideoPlayerProps {
  videoId?: string; // Make id optional
}

const useParam = useParams<{ id: any; type: string; selectedVideoIndex?: string }>;

export const NKVideoPlayer: React.FC<NKVideoPlayerProps> = ({ videoId }) => {
  const currentLongVideoSelected = useFeedStore((state) => state.currentLongVideoSelected);
  const setLongVideoSelected = useFeedStore((state) => state.setLongVideoSelected);
  const updateLongVideoCommentCount = useFeedStore((state) => state.updateLongVideoCommentCount);
  const videoContent = currentLongVideoSelected?.actionData?.content;
  // console.log('Current long video selected => ', videoContent?.id);
  const landscape = [OrientationType['LANDSCAPE-LEFT'], OrientationType['LANDSCAPE-RIGHT']];
  const portrait = [OrientationType.PORTRAIT, OrientationType['PORTRAIT-UPSIDEDOWN']];
  const isFullScreenRef = useRef(false);
  const navigation = useNavigation();
  const { push, back } = useRouter();
  const edgeinsets = useSafeAreaInsets();
  const { t } = useTranslation();
  const [isFullScreen, setIsFullScreen] = React.useState<boolean>(false);
  const [playlist, setPlaylist] = useState<PlayList>({ items: [], currentIndex: 0 });
  const [showFullText, setShowFullText] = useState([]);
  const userProfile = useProfileStore((state) => state.userProfile);
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const { type: feedType } = useParam();
  let { id: itemId } = useParam();
  if (videoId) {
    itemId = videoId;
  }
  const currentInfoRef = useRef({
    currentTime: 0,
  });
  const timeoutRef = useRef<any | null>(null);
  const [commentsCount, setCommentsCount] = useState(0);
  const findAndUpdateFeed = useFeedStore((state) => state.findAndUpdateFeed);
  const [currentPlayingVideo, setCurrentPlayingVideo] = useState<IRemoteVideoMetadata>();
  const colorScheme = Appearance.getColorScheme();
  const bannerAdKeywords = useEventZStore((state) => state.bannerAdKeywords);
  const deviceWidth = Dimensions.get('window').width;
  const [source, setSource] = React.useState<NKSource>({
    source: {
      uri: '',
    },

    poster: '',
    title: videoContent?.name,
    itemKey: videoContent?.id.toString() || '',
  });

  const playerRef = React.useRef<NKPlayerRef>(null);
  const [longStreamVideos, setLongStreamVideos] = useState<IRemoteVideoMetadata[]>([]);
  const [like, setLike] = useState(false);
  const [threds, setThreds] = useState([]);
  const [feedItem, setFeedItem] = useState<IRemoteVideoMetadata>();
  const [likeCount, setLikeCount] = useState(0);
  const latitude = useProfileStore((state) => state.latitude);
  const longitude = useProfileStore((state) => state.longitude);
  const [isLoaded, setIsLoaded] = useState<boolean>(true);
  const isRecommendedRef = useRef(false);
  const adId = useAppPersistenceStore?.getState()?.adId;
  const isAdTrackingLimited = useAppPersistenceStore.getState().isAdTrackingLimited;
  const uniqueDeviceId = useAppPersistenceStore((state) => state.deviceId);
  const isVideoplayerAdEnable = useEventZStore((state) => state?.isVideoplayerAdEnable);
  const appVersion = getVersion();
  const [config, setConfig] = React.useState<NKConfig>({
    posterResizeMode: 'cover',
    layoutMode: 'advanced',
    autoPlay: true,
    resizeMode: 'contain',
    brightness: 75,
    repeat: false,
    disableMore: true,
    disableBack: false,
    disableSubtitle: true,
    disablePlayList: true,
  });
  const startTimeRef = useRef(performance.now());
  const [hasVideoPaused, setHasVideoPaused] = useState(false);
  const [commentbottomSheet, setCommentbottomSheet] = useState<boolean>(false);
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);
  const [isFollowing, setIsFollowing] = useState(
    hasUserLoggedIn() ? videoContent?.following : false
  );
  const nav = useNavigation();
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const processEvents = useRef(useQueuedEventStore((state) => state.processEvents)).current;

  const longVideos = useFeedStore((state) => state.longVideos);
  const setLongVideos = useFeedStore((state) => state.setLongVideos);
  const toast = useToastController();

  const videoViewedFiveEventtriggered = useRef(false);
  const videoProgressEventtriggered = useRef(false);
  const lastTriggeredTime = useRef(0);

  const payLoadRef = useRef({ offset: 0, count: 10 });

  const streamUrl = getStreamURI();
  const fields = useGlobalLoginContext(['openLoginSheet','previousPage', 'navigationParams']);
  const setNavigationParams = fields.navigationParams.set;

  const switchToRecommendList = async (index: number) => {
    await updateCurrentIndexWithPlaybackChange(index);
  };

  const onBackPress = () => {
    if (!navigation?.canGoBack()) {
      navigation?.reset({
        index: 0,
        routes: [{ name: '(tabs)' }],
      });
      return true;
    }

    if (navigation?.canGoBack()) {
      Orientation.lockToPortrait();
      const endTime = performance.now();
      const screenTiming = msToTime(endTime - startTimeRef.current);
      const backPressEvent: INinjaEvent = {
        name: KissanEventType.BACK_PRESS,
        screenDetails: {
          screen: itemId
            ? 'notification clicked video'
            : isRecommendedRef?.current
              ? 'feed recommended video'
              : 'feed video',
          screenTimeInSecs: screenTiming,
        },
        eventParams: [
          addEventParam('videoId', Number(videoContent?.id ?? itemId)),
          addEventParam('recommendationId', videoContent?.recommendationId),
        ],
      };
      enqueue(backPressEvent);
      navigation?.goBack();

      return true;
    }

    return true;
  };

  const enqueueEvent = (
    eventName: KissanEventType,
    additionalParams: { key: string; value: any }[] = [],
    customScreenDetails?: { screen?: string; screenTimeInSecs?: number }
  ) => {
    const commonDetails = [
      addEventParam(
        'deeplinkingUrl',
        `ninjakisan://longVideo/${Number(videoContent?.id ?? itemId)}?type=STREAM`
      ),
      addEventParam('videoId', Number(videoContent?.id ?? itemId)),
      addEventParam('recommendationId', videoContent?.recommendationId),
      addEventParam('eventId', currentLongVideoSelected?.actionData?.content?.eventId),
    ];
    const additionalDetails = [...commonDetails, ...additionalParams];
    const defaultScreenDetails = {
      screen: itemId
        ? 'notification clicked video'
        : isRecommendedRef?.current
          ? 'feed recommended video'
          : 'feed video',
    };
    const screenDetails = {
      ...defaultScreenDetails,
      ...customScreenDetails,
    };
    const event: INinjaEvent = {
      name: eventName,
      screenDetails,
      eventParams: additionalDetails,
    };
    processEvents([event]);
  };

  useEffect(() => {
    if (Platform.OS != 'web') {
      const backHandler = BackHandler.addEventListener('hardwareBackPress', onBackPress);
      Orientation.addDeviceOrientationListener(onOrientationDidChange);
      StatusBar.setBarStyle('light-content', true);
      StatusBar.setBackgroundColor('black');
      return () => {
        backHandler.remove();
        // NKPlayerModule.showSystemBar();
        setLongVideoSelected(undefined);
        StatusBar.setBackgroundColor('transparent');
        StatusBar.setBarStyle(colorScheme === 'dark' ? 'light-content' : 'dark-content', true);
        Orientation.removeDeviceOrientationListener(onOrientationDidChange);
      };
    }
  }, []);

  useEffect(() => {
    console.log('Current long video selected => ', currentLongVideoSelected);
  }, [currentLongVideoSelected]);

  useEffect(() => {
    setIsFollowing(videoContent?.following);
  }, [videoContent]);

  const handleAutoFullScreenEvent = (isFullScreen) => {
    enqueueEvent(KissanEventType.FULLSCREEN_AUTO_LOAD, [addEventParam('type', isFullScreen)]);
  };

  const onOrientationDidChange = (orientation: OrientationType) => {
    if (landscape.indexOf(orientation) > -1) {
      if (!isFullScreen) {
        // Only trigger if not already full screen
        setIsFullScreen(true);
        handleAutoFullScreenEvent('AUTO_ENTER_FULLSCREEN');
        playerRef?.current?.setFullScreenMode(true);
        Orientation.lockToLandscape();
      }

      // setIsFullScreen(true);
      // handleAutoFullScreenEvent('AUTO_ENTER_FULLSCREEN');
      // playerRef?.current?.setFullScreenMode(true);
      // // NKPlayerModule.hideSystemBar();
      // Orientation.lockToLandscape();
    } else {
      if (isFullScreen) {
        // Only trigger if currently in full screen
        setIsFullScreen(false);
        playerRef?.current?.setFullScreenMode(false);
        handleAutoFullScreenEvent('AUTO_EXIT_FULLSCREEN');
        Orientation.lockToPortrait();
      }
      // setIsFullScreen(false);
      // // NKPlayerModule.hideSystemBar();
      // playerRef?.current?.setFullScreenMode(false);
      // handleAutoFullScreenEvent('AUTO_EXIT_FULLSCREEN');
      // Orientation.lockToPortrait();
    }
  };

  React.useLayoutEffect(() => {}, [navigation, isFullScreen]);

  useEffect(() => {
    if (currentLongVideoSelected || itemId) {
      const getFeedType = feedType ?? currentLongVideoSelected?.type ?? 'STREAM';
      setIsFullScreen(false);
      init(getFeedType);
    }
  }, [currentLongVideoSelected, itemId]);

  const handleTranscodingErrorEvent = () => {
    const transcodingErrorEvent: INinjaEvent = {
      name: KissanEventType.TRANSCODING_ERROR,
      screenDetails: {
        screen: itemId
          ? 'notification clicked video'
          : isRecommendedRef?.current
            ? 'feed recommended video'
            : 'feed video',
      },
      eventParams: [addEventParam('videoId', Number(videoContent?.id ?? itemId))],
    };
    enqueue(transcodingErrorEvent);
  };

  const getRecommendedVideos = async (currentVideo) => {
    const feedDetail = transformToPlaylistItem(currentVideo!);
    let payload = {
      offset: payLoadRef.current.offset,
      count: payLoadRef.current.count,
      videoId: itemId ?? videoContent?.id ?? videoContent?.videoId,
      geoLatitude: latitude,
      geoLongitude: longitude,
      eventId: '',
    };

    if (!itemId) {
      payload.eventId = videoContent?.eventId?.toString() ?? '';
    }
    const data = await getPlayListItem(payload);
    const { items, offset, count } = data;
    if (items) {
      const resolvedToPlayListItem: PlayListItem[] = items
        ?.filter((item) => item?.id !== undefined)
        ?.map((item) => transformToPlaylistItem(item));
      setLongStreamVideos([...longStreamVideos, ...items]);
      setIsLoaded(false);
      const videos = [feedDetail!, ...resolvedToPlayListItem];
      setPlaylist({
        items: videos,
        currentIndex: 0,
      });
      payLoadRef.current.offset = offset;
      payLoadRef.current.count = count;
    }
    return items;
  };

  async function init(feedType: string) {
    try {
      const data = await getVideoDetails(videoContent?.videoId ?? itemId);
      setFeedItem(data?.data);
      setCurrentPlayingVideo(data?.data);

      if (data?.data?.streamingPlaylists && data?.data?.streamingPlaylists?.length <= 0) {
        handleTranscodingErrorEvent();
        if (Platform.OS === 'web') {
          window.alert('Video will be available soon. Redirecting to feeds.');
          // if (navigation?.canGoBack()) {
          //   navigation.goBack();
          // } else {
          //   push(ROUTES.FEED_LIST);
          // }
          push('/tabs');
        }
        Alert.alert(
          'Video will be available soon',
          'Redirecting to feeds',
          [
            {
              text: 'OK',
              onPress: () => {
                navigation?.canGoBack() ? navigation.goBack() : push(ROUTES.FEED_LIST);
              },
            },
          ],
          { cancelable: false }
        );
        console.log('No streaming playlist found');
        return;
      }

      if (data?.data) {
        setLongStreamVideos([data?.data!]);
        setIsLoaded(false);
      }
      setCurrentPlayingVideo(data?.data!);
      getRecommendedVideos(data?.data);
    } catch (error) {
      console.log('Error initializing video rendering:', error);
    }
  }

  const getRecommendedItems = async (feedDetail: PlayListItem) => {
    let payload = {
      offset: 0,
      count: 10,
      videoId: itemId ?? videoContent?.id ?? videoContent?.videoId,
      geoLatitude: latitude,
      geoLongitude: longitude,
    };

    const items = await getPlayListItem(payload);
    if (items) {
      const resolvedToPlayListItem: PlayListItem[] = items?.map((item) =>
        transformToPlaylistItem(item)
      );
      setLongStreamVideos([...longStreamVideos, ...items]);
      setIsLoaded(false);
      const videos = [feedDetail!, ...resolvedToPlayListItem];
      setPlaylist({
        items: videos,
        currentIndex: 0,
      });
    }
  };

  async function updateLikeOnPlaybackChange(item: IRemoteVideoMetadata) {
    try {
      if (!hasUserLoggedIn() || !item?.id) return;
      console.log('User logged in. Checking whether he has liked an post!!!');
      const likedUpdate = await updateLikedStream(item?.id.toString());
      const Liked: any = likedUpdate?.rating === 'like';
      if (likedUpdate) {
        setLike(Liked);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (longStreamVideos[playlist?.currentIndex!]) {
      updateLikeOnPlaybackChange(longStreamVideos[playlist?.currentIndex!]);
      setLikeCount(longStreamVideos[playlist?.currentIndex!]?.likes);
      console.log(
        'longStreamVideos[playerPlaylist?.currentIndex!]?.likes',
        longStreamVideos[playlist?.currentIndex!]?.likes
      );
      commentSectionData(longStreamVideos[playlist?.currentIndex!]);
    }
  }, [playlist]);

  useEffect(() => {
    LikeUpdateFn();
  }, [like, currentPlayingVideo]);

  async function LikeUpdateFn(index?: number | any) {
    if (longStreamVideos?.length) {
      longStreamVideos[index ? index : playlist?.currentIndex].liked = like;
      if (currentPlayingVideo?.likes) {
        longStreamVideos[index ? index : playlist?.currentIndex].likes = currentPlayingVideo.likes;
      }
    }
  }

  const commentSectionData = async (item) => {
    if (!hasUserLoggedIn()) return;
    try {
      let data;
      let commentsData;
      let totalComments;
      const type = isFeedOrStream(item);
      if (type === 'STREAM') {
        let payload = {
          id: item?.id,
          start: 0,
          count: 10,
        };
        data = await getVideoComments(payload);
        commentsData = transformStreamComment(data);
      } else {
        data = await getThredsApi(videoContent?.id!);
        commentsData = transformFeedComment(data?.descendants);
      }

      if (commentsData && commentsData?.length) {
        totalComments = data?.total || commentsData?.length;
        setCommentsCount(totalComments);
        const currentVideo = longStreamVideos[playlist.currentIndex!];
        if (currentVideo) {
          currentVideo.comments_count = totalComments;
          const updateLongVideoData = longStreamVideos[playlist?.currentIndex!];
          updateLongVideoData.comments_count = totalComments;
          longStreamVideos[playlist?.currentIndex!] = updateLongVideoData;
          updateLongVideoCommentCount(updateLongVideoData?.id?.toString(), totalComments);
        }
      }
    } catch (error) {
      console.error('Error fetching thread data:', error);
    }
  };

  const isFeedOrStream = (item: IRemoteVideoMetadata) => {
    if (item?.channel?.name?.startsWith('feed')) {
      return 'FEED';
    }

    return 'STREAM';
  };

  const playListcurrentIndex = playlist?.currentIndex ?? 0;

  const hideTabBar = () => {
    navigation?.setOptions({
      tabBarStyle: { display: 'none' },
    });
  };

  const onFullScreenModeUpdate = async (fullScreen: boolean, index?: number) => {
    console.log('Called full screen mode update!!!', isFullScreenRef.current);

    if (fullScreen) {
      // true;

      // hideTabBar();
      setIsFullScreen(fullScreen);
      isFullScreenRef.current = fullScreen;
      Orientation.lockToLandscape();
      // hideTabBar();
    } else {
      // showTabBar()
      setIsFullScreen(fullScreen);
      Orientation.lockToPortrait();
    }
  };

  const handleFullScreenEvent = (isFullScreen) => {
    enqueueEvent(KissanEventType.FULLSCREEN_BUTTON_CLICKED, [addEventParam('type', isFullScreen)]);
  };

  const onToggleFullScreen = async (fullScreen: boolean, index?: number) => {
    isFullScreenRef.current = !fullScreen;
    Orientation.getOrientation((orientation) => {
      if (isFullScreenRef.current) {
        setIsFullScreen(false);
        handleFullScreenEvent('EXIT_FULLSCREEN');
        playerRef?.current?.setFullScreenMode(false);
        Orientation.lockToPortrait();
      } else {
        setIsFullScreen(true);
        handleFullScreenEvent('ENTER_FULLSCREEN');
        playerRef?.current?.setFullScreenMode(true);
        Orientation.lockToLandscape();
      }
    });
  };

  const onBackPressed = () => {
    if (!isFullScreen) {
      Orientation.lockToPortrait();
    } else {
      navigation?.goBack();
    }
    return true;
  };

  const onLoad = (data: any) => {};

  const onLoadStart = (data: any) => {
    startTimeRef.current = performance.now();
    enqueueEvent(KissanEventType.VIDEO_ON_READY_TIME);
  };

  const handleOnPlayEvent = () => {
    const bufferEndTime = performance.now();
    enqueueEvent(KissanEventType.VIDEO_PLAY);
    const calculatedBufferTime = msToTime(bufferEndTime - startTimeRef.current);
    if (calculatedBufferTime && !hasVideoPaused) {
      bufferTimeCapture(calculatedBufferTime);
    }
  };

  const bufferTimeCapture = (calculatedBufferTime) => {
    enqueueEvent(KissanEventType.VIDEO_BUFFER_TIME, [
      addEventParam('bufferTime', calculatedBufferTime),
    ]);
  };

  const onPaused = () => {
    setHasVideoPaused(true);
    enqueueEvent(KissanEventType.VIDEO_PAUSED);
  };

  const onEnd = async () => {
    const endTime = performance.now();
    const screenTiming = msToTime(endTime - startTimeRef.current);
    console.log('CAlling on end event');
    enqueueEvent(KissanEventType.VIDEO_PLAY_FINISH, [], { screenTimeInSecs: screenTiming });

    if (playlist.currentIndex != undefined) {
      const nextVideoItem = playlist.currentIndex! + 1;
      await updateCurrentIndex(nextVideoItem);

      console.log('playlist.currentIndex', playlist.currentIndex, nextVideoItem);
    }
  };

  const onSkipNext = async (index: number) => {
    await updateCurrentIndex(index);
  };

  const onSkipBack = async (index: number) => {
    await updateCurrentIndex(index);
  };

  const handleRecommendedVideoEvent = () => {
    isRecommendedRef.current = true;
    enqueueEvent(KissanEventType.FEED_RELATED_VIDEO_CLICKED, [
      addEventParam('videoIndex', videoContent?.itemIndex),
    ]);
  };

  const updateCurrentIndexWithPlaybackChange = (index: number) => {
    setIsLoaded(true);
    setCommentsCount(0);
    playerRef?.current?.setFullScreenMode(false);
    const selectedPlayListItem = longStreamVideos[index!];
    // console.log(
    //   'Selected video from recommended => ',
    //   JSON.stringify(playlist?.items),
    //   playlist?.items?.[index]?.itemSource?.itemKey
    // );
    handleRecommendedVideoEvent();
    if (selectedPlayListItem) {
      const adaptiveActionFormat: IAdaptiveActionCard = {
        type: 'STREAM',
        actionData: {
          contentType: 'json',
          content: {
            id: selectedPlayListItem?.id?.toString() ?? '',
            postOwnerId: selectedPlayListItem?.postOwnerId ? selectedPlayListItem?.postOwnerId : '',
            videoId: selectedPlayListItem?.id?.toString() ?? '',
            name: '',
            description: '',
            avatar: '',
            likes_count: selectedPlayListItem?.likes ?? selectedPlayListItem?.likesCount,
            liked: false,
            comments_count: selectedPlayListItem?.commentsCount,
            tags: [],
            created_at: selectedPlayListItem?.createdAt,
            unitId: '',
            recommendationId: '',
            itemIndex: 0,
            streamingPlaylistUrl:
              selectedPlayListItem?.streamingPlaylistUrl ??
              selectedPlayListItem?.streamingPlaylists?.[0]?.playlistUrl,
            commentsCount: selectedPlayListItem?.commentsCount,
            likesCount: selectedPlayListItem?.likesCount ?? 0,
            viewsCount: selectedPlayListItem?.viewsCount ?? selectedPlayListItem?.views,
            truncatedDescription:
              selectedPlayListItem?.truncatedDescription ?? selectedPlayListItem?.name,
            userHistory: selectedPlayListItem?.userHistory,
            following: selectedPlayListItem?.following ? selectedPlayListItem?.following : false,
            eventId: selectedPlayListItem?.eventId,
          },
          mediaDetails: [],
          props: [],
          eventNamePrefix: '',
        },
      };
      console.log('Video Id => ', selectedPlayListItem?.id?.toString());
      setLongVideoSelected(adaptiveActionFormat);
    }
  };

  const updateCurrentIndex = async (index: number) => {
    setCommentsCount(0);
    setPlaylist((prevState) => {
      console.log('Prev item => ', prevState);
      return {
        ...prevState,
        currentIndex: index,
      };
    });

    if (index === 0) {
      const newSourceConfig = config;
      newSourceConfig.disableBack = true;
      setConfig(newSourceConfig);
    }

    if (index > 0 && config.disableBack) {
      const newSourceConfig = config;
      newSourceConfig.disableBack = false;
      setConfig(newSourceConfig);
    }
    setLike(false);

    setFeedItem(longStreamVideos[index]);
    await LikeUpdateFn(index);
  };

  const toggleText = (index: number) => {
    console.log('Text index => ', index);
    setShowFullText((prevShowFullText) => {
      console.log('Text prev => ', ...prevShowFullText);
      const newShowFullText: any = [...prevShowFullText];
      newShowFullText[index] = !prevShowFullText[index];
      console.log('Text new => ', newShowFullText);
      return newShowFullText;
    });
  };

  const viewStyle: StyleProp<ViewStyle> = isFullScreen
    ? {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 9999,
      }
    : { position: 'relative', height: 450, zIndex: 9999 };

  const handleLikedEvent = () => {
    enqueueEvent(KissanEventType.ITEM_LIKED, [addEventParam('type', 'Post Video Liked')]);
    const additionalDetails = [
      addEventParam('type', 'Post Video Liked'),
      addEventParam(
        'deeplinkingUrl',
        `ninjakisan://longVideo/${Number(videoContent?.id ?? itemId)}?type=STREAM`
      ),
      addEventParam('videoId', Number(videoContent?.id ?? itemId)),
      addEventParam('recommendationId', videoContent?.recommendationId),
      addEventParam('eventId', currentLongVideoSelected?.actionData?.content?.eventId),
    ];
    handleMarketingEvents(
      KissanEventType.ITEM_LIKED,
      {
        screen: itemId
          ? 'notification clicked video'
          : isRecommendedRef?.current
            ? 'feed recommended video'
            : 'feed video',
      },
      additionalDetails
    );
  };

  const handleDislikedEvent = () => {
    enqueueEvent(KissanEventType.ITEM_DISLIKED, [addEventParam('type', 'Post Video DisLiked')]);
  };

  const handleLike = async (item) => {
    handleLikedEvent();
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('Feed-video');
      setNavigationParams({
        name: '',
        routeName: { name: `longVideo/${item?.id}`, params: { id: item?.id } },
        description: `${t('page.likeOnHomePage')}`,
        screenName: 'Feed-video',
      });
      
      return;
    }
    try {
      const likedID = item?.id;
      setLike(!like);
      longStreamVideos[playlist?.currentIndex!].liked =
        !longStreamVideos[playlist?.currentIndex!].liked;
      longStreamVideos[playlist?.currentIndex!].likes += longStreamVideos[playlist?.currentIndex!]
        .liked
        ? 1
        : -1;
      setLikeCount(Math.max(longStreamVideos[playlist?.currentIndex!].likes, 0));
      if (longStreamVideos[playlist?.currentIndex!]?.liked) {
        await onVideoLike(likedID, 'like');
        handleLikedEvent();
      } else {
        await onVideoLike(item?.id, 'none');
        handleDislikedEvent();
      }
    } catch (error) {
      setLike(like);
      setLikeCount(longStreamVideos[playlist?.currentIndex!].likes);
      console.error('API Error:', error);
    }
  };

  const onCommentBottomData = async (item, index) => {
    if (!hasUserLoggedIn()) {
      push('/login');
      return;
    }
    try {
      const data: any = await getThredsApi(item?.id);
      enqueueEvent(KissanEventType.ITEM_COMMENT, [addEventParam('type', 'Post Video Comment')]);
      const additionalDetails = [
        addEventParam('type', 'Post Video Comment'),
        addEventParam(
          'deeplinkingUrl',
          `ninjakisan://longVideo/${videoContent?.id ?? itemId}?type=STREAM`
        ),
        addEventParam('videoId', Number(videoContent?.id ?? itemId)),
        addEventParam('recommendationId', videoContent?.recommendationId),
        addEventParam('eventId', currentLongVideoSelected?.actionData?.content?.eventId),
      ];
      handleMarketingEvents(
        KissanEventType.ITEM_COMMENT,
        {
          screen: itemId
            ? 'notification clicked video'
            : isRecommendedRef?.current
              ? 'feed recommended video'
              : 'feed video',
        },
        additionalDetails
      );
      if (data) {
        let commentsData = data?.descendants;
        setThreds(commentsData);
      }
    } catch (error) {}
  };

  const onCommentBottomSheetOpen = () => {
    handleVideoComment();
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('Feed-video');
      setNavigationParams({
        name: '',
        routeName: {
          name: `longVideo/${longStreamVideos[playlist?.currentIndex!]?.id}`,
          params: { id: longStreamVideos[playlist?.currentIndex!]?.id },
        },
        description: `${t('page.commentOnHomePage')}`,
        screenName: 'Feed-video',
      });
      return;
    }
    setCommentbottomSheet(true);
  };

  const handleVideoComment = () => {
    enqueueEvent(KissanEventType.ITEM_COMMENT, [addEventParam('type', 'Post Video Comment')]);
  };

  const handleShareEvent = () => {
    enqueueEvent(KissanEventType.ITEM_SHARED, [addEventParam('type', 'Post Video Share')]);
  };

  const handleShare = async (item) => {
    handleShareEvent();
    try {
      // Get share URL once (common for web and mobile)
      const response = await getSeoUrl({ id: item?.id, type: 'Stream' });
      let shareUrl = response?.url;
      if (userProfile?.user?.referralCode) {
        shareUrl += `?refCode=${userProfile?.user?.referralCode}`;
      }

      // Prepare message
      const cleanedDescription =
        videoContent?.description
          ?.replace(/#[^\s]+/g, '')
          .replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '') ||
        longStreamVideos[playListcurrentIndex]?.description
          ?.replace(/#[^\s]+/g, '')
          .replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '');

      const message = `${cleanedDescription} \n \n Click here to watch: \n ${shareUrl}`;

      if (Platform.OS === 'web') {
        // Web sharing logic
        if (navigator.share) {
          await navigator.share({
            title: t('page.checkOutThisVideo'),
            text: cleanedDescription,
            url: shareUrl,
          });
        }
      } else {
        // Mobile sharing logic
        const result = await Share.share({ message });
        if (result.action === Share.sharedAction) {
          if (result.activityType) {
            // shared with activity type of result.activityType
          } else {
            // shared
          }
        } else if (result.action === Share.dismissedAction) {
          // dismissed
        }
      }
    } catch (error: any) {
      Alert.alert(error.message);
    }
  };

  const eventPublishV2 = async (seekTimeConst: number, duration: number, itemKey?: string) => {
    try {
      if (seekTimeConst > duration) return;

      if (!itemKey) return;

      await updateVideoStreamPlayback(itemKey, seekTimeConst ?? 0, uniqueDeviceId);
      handleVideoProgressEvent(itemKey);
    } catch (err) {
      console.error('Error publish video playback event. ', err);
    }
  };

  const handleVideoProgressEvent = (videoId: string) => {
    enqueueEvent(KissanEventType.VIDEO_PROGRESS, [
      addEventParam('itemId', videoId),
      addEventParam('videoPlaybackTime', currentInfoRef?.current?.currentTime),
    ]);
  };

  const onPlaybackStateChanged = (e) => {
    const currentTime = currentInfoRef?.current?.currentTime;
    const currentIndex = playlist?.currentIndex ?? 0;
    const userHistory = longStreamVideos[currentIndex]?.userHistory;
    if (e.isPlaying) {
      handleOnPlayEvent();
    }
  };
  const adEventMap = {
    LOADED: KissanEventType.ADS_LOADED,
    STARTED: KissanEventType.ADS_STARTED,
    PAUSED: KissanEventType.ADS_PAUSED,
    FIRST_QUARTILE: KissanEventType.ADS_FIRST_QUARTILE,
    MIDPOINT: KissanEventType.ADS_MIDPOINT,
    THIRD_QUARTILE: KissanEventType.ADS_THIRD_QUARTILE,
    COMPLETED: KissanEventType.ADS_COMPLETED,
    CONTENT_PAUSE_REQUESTED: KissanEventType.VIDEO_CONTENT_PAUSE_REQUESTED,
    CONTENT_RESUME_REQUESTED: KissanEventType.VIDEO_CONTENT_RESUME_REQUESTED,
    SKIPPED: KissanEventType.ADS_SKIPPED,
    ALL_ADS_COMPLETED: KissanEventType.ALL_ADS_COMPLETED,
  };

  const onReceiveAdEvent = (e) => {
    // console.log('On receive ad event => ', e);
    if (e?.event === 'PAUSED') {
      // console.log('Ad pause requested!!! Resuming play');
      playerRef?.current?.play();
    }

    if (e?.event === 'CONTENT_RESUME_REQUESTED') {
      // console.log('Ad pause requested!!! Resuming play');
      playerRef?.current?.play();
    }

    const eventName = adEventMap[e?.event];
    if (eventName) {
      enqueueEvent(eventName);
    }
  };

  const handleAspectRatioClickedEvent = () => {
    enqueueEvent(KissanEventType.ASPECTRATIO_CLICKED);
  };
  const onAspectRatioPress = () => {
    handleAspectRatioClickedEvent();
  };

  const handleVideoViwedLessThanFiveSecondsEvent = () => {
    enqueueEvent(KissanEventType.VIDEO_VIEWED_LESS_THAN_FIVE_SECONDS);
    videoViewedFiveEventtriggered.current = true;
  };

  const onProgress = async (data: OnProgressDataWithItemKey) => {
    const currentSeekTime = Math.round(data.currentTime);
    const seekTimeConst = Math.round(data.currentTime) || 0;
    if (currentSeekTime) {
      currentInfoRef.current = {
        currentTime: seekTimeConst,
      };
      if (currentSeekTime % 10 === 0 && currentSeekTime !== lastTriggeredTime.current) {
        if (videoProgressEventtriggered.current === false) {
          videoProgressEventtriggered.current = true;
          lastTriggeredTime.current = currentSeekTime;
          await eventPublishV2(seekTimeConst, data.seekableDuration, data?.itemKey);
        }
      } else {
        videoProgressEventtriggered.current = false;
      }
    }
    if (seekTimeConst === 5) {
      if (videoViewedFiveEventtriggered.current === false) {
        handleVideoViwedLessThanFiveSecondsEvent();
      }
    }
  };

  function renderDescription() {
    const description =
      longStreamVideos[playlist.currentIndex!]?.description ??
      currentLongVideoSelected?.actionData?.content?.description;
    if (!description) {
      if (Platform.OS === 'web') {
        return '';
      } else {
        return renderVideoName();
      }
    }

    const withoutLinks = description.replace(/https:\/\/youtu\.be\/\w+/g, '');
    const withoutHashtags = withoutLinks.replace(/#\w+/g, '');
    const cleanedText = withoutHashtags.replace(/(\.\n)+/g, '\n').trim();
    const lines = cleanedText.split('\n').slice(0, 50);
    const text = lines.join('\n');
    return text.trim() || '';
  }

  function renderVideoName() {
    const text =
      longStreamVideos[playlist.currentIndex!]?.name ??
      currentLongVideoSelected?.actionData?.content?.name;
    return text || '';
  }

  const renderVideoDescription = () => {
    return (
      <Paragraph
        paddingHorizontal={16}
        paddingTop={5}
        fontSize={14}
        fontWeight={'500'}
        lineHeight={24}
        ellipsizeMode={showFullText[playListcurrentIndex] ? 'tail' : 'head'}
      >
        {showFullText[playlist.currentIndex!]
          ? renderDescription()?.replace(/^(\s*\.\s*)+|\s+/g, ' ')
          : renderDescription()
              ?.replace(/^(\s*\.\s*)+|\s+/g, ' ')
              ?.slice(0, 80) + ' '}
        {renderDescription()?.length > 100 && (
          <Content color={'$primary'} onPress={() => toggleText(playlist.currentIndex!)}>
            {showFullText[playlist.currentIndex!]
              ? `  ${t('page.readLess')}`
              : `...  ${t('page.readMore')}`}
          </Content>
        )}
      </Paragraph>
    );
  };

  const updateFollowState = (prevState, postOwnerId) => {
    return longVideos?.map((el) => {
      if (el?.type === 'STREAM' && el?.actionData?.content?.postOwnerId === postOwnerId) {
        return {
          ...el,
          actionData: {
            ...el.actionData,
            content: {
              ...el.actionData.content,
              following: !prevState,
            },
          },
        };
      }
      return el;
    });
  };

  const updateConnectionStatus = async () => {
    try {
      const prevState = isFollowing;
      setIsFollowing(!isFollowing);
      let config = {
        type: isFollowing ? 'unfollow' : 'follow',
        formData: {
          sourceObjectId: userProfile?.user?.id ?? '-1',
          sourceObjectType: 'USER',
          destinationObjectId: longStreamVideos[playlist.currentIndex!]?.account?.name,
          destinationObjectType: 'USER',
          associationType: 'FOLLOWED',
        },
      };
      const response: boolean = await updateFollowStatusApi(config);
      handleContactPermission();
      captureFollowEvent(longStreamVideos[playlist.currentIndex!]?.account?.name);
      const followState = response ? prevState : !prevState;
      const updatedLongVideos = updateFollowState(
        followState,
        longStreamVideos[playlist.currentIndex!]?.account?.name
      );
      setLongVideos(updatedLongVideos);
      if (!response) {
        setIsFollowing(prevState);
      }
    } catch (error) {
      setIsFollowing(isFollowing);
      console.error('Error updating Connection Status', error);
    }
  };

  const handleButtonClick = async () => {
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('Feed-video');
      setNavigationParams({
        name: '',
        routeName: {
          name: `profile/[id]`,
          params: {
            id: currentLongVideoSelected?.actionData?.content?.postOwnerId,
            name: truncateName(longStreamVideos[playlist.currentIndex!]?.account?.displayName, 15),
          },
        },
        description: `${t('page.toFollow')}`,
        screenName: 'Feed-video',
      });
      return;
    }
    updateConnectionStatus();
  };

  const handleViewProfileClick = () => {
    const isInvalidOwner = isInvalidPostOwnerId(
      currentLongVideoSelected?.actionData?.content?.postOwnerId
    );
    const isCurrentUser =
      currentLongVideoSelected?.actionData?.content?.postOwnerId === userProfile?.user?.id;
    if (isInvalidOwner)
      return toast.show('', {
        message: `${t('page.profileNotAvailable')}`,
      });
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('Feed-video');
      setNavigationParams({
        name: '',
        routeName: isCurrentUser
          ? '/profileDetail'
          : {
              name: `/profile/${currentLongVideoSelected?.actionData?.content?.postOwnerId}`,
            },
        description: `${t('page.viewOnProfilePage')}`,
        screenName: 'Feed-video',
      });
    } else {
      push(
        isCurrentUser
          ? '/profileDetail'
          : {
              pathname: `/profile/${currentLongVideoSelected?.actionData?.content?.postOwnerId}`,
            }
      );
    }
  };

  const captureFollowEvent = (followID) => {
    const additionalDetails = [
      addEventParam('userId', userProfile?.user?.id),
      addEventParam('followedUserId', followID),
    ];
    const userFollowed: INinjaEvent = {
      name: KissanEventType.FOLLOW_SHORTS_PAGE,
      screenDetails: { screen: 'Feed Video page' },
      eventParams: additionalDetails,
    };
    enqueue(userFollowed);
  };

  const renderVideoHeader = () => {
    return (
      <XStack paddingHorizontal={16} paddingTop={5} alignItems="center">
        <Pressable onPress={handleViewProfileClick} style={{ flexDirection: 'row' }}>
          <Avatar circular size="$4">
            <Avatar.Image accessibilityLabel="Nate Wienert" src={FallBackImage} />
            <Avatar.Fallback delayMs={600} />
          </Avatar>
          <YStack paddingHorizontal={8} display="flex" justifyContent="center" alignItems="center">
            <Paragraph
              color={'$color'}
              fontSize={appLanguage == 'ta' ? 12 : 18}
              fontWeight={'600'}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {longStreamVideos[playlist.currentIndex!]?.account?.displayName}
            </Paragraph>
          </YStack>
        </Pressable>

        <FollowButton
          isFollowing={isFollowing}
          isFollowLoading={false}
          handleButtonClick={handleButtonClick}
        />
      </XStack>
    );
  };

  const renderVideoLikeCommentSection = () => {
    if (isFullScreen) {
      return true;
    }
    return (
      <View>
        {Platform.OS === 'web' && (
          <Paragraph
            paddingHorizontal={16}
            paddingTop={5}
            fontSize={14}
            fontWeight={'700'}
            lineHeight={24}
          >
            {renderVideoName()}
          </Paragraph>
        )}
        {renderVideoDescription()}
        {renderVideoHeader()}
        <Stack borderTopColor={'#D9D9D9'} marginTop={4} borderTopWidth={1}></Stack>
        <XStack
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'transparent',
          }}
          paddingHorizontal={14}
          paddingVertical={20}
        >
          <XStack flex={1} justifyContent="flex-start">
            <Pressable onPress={() => handleLike(longStreamVideos[playlist?.currentIndex!])}>
              <XStack>
                {!like ? (
                  <LikeRegular color={'$commentSectionTextColor'} size={25} />
                ) : (
                  <LikeSolidRegular color={'$primary'} size={25} />
                )}
                <Content color={'$commentSectionTextColor'} marginLeft={5}>
                  {likeCount ?? '0'}
                </Content>
              </XStack>
            </Pressable>
          </XStack>
          <Pressable style={{ flex: 1 }} onPress={onCommentBottomSheetOpen}>
            <XStack flex={1} justifyContent="center">
              <MessageCircle color={'$commentSectionTextColor'} />
              <Paragraph
                marginLeft={5}
                fontSize={14}
                fontWeight={'500'}
                color={'$commentSectionTextColor'}
              >
                {commentsCount
                  ? commentsCount
                  : (longStreamVideos[playlist?.currentIndex!]?.comments_count ?? 0)}
              </Paragraph>
            </XStack>
          </Pressable>
          {/* You can include BottomSheet component here if needed */}
          <XStack
            flex={1}
            justifyContent="flex-end"
            onPress={() => handleShare(longStreamVideos[playlist?.currentIndex!])}
          >
            <ShareRegular color={'$commentSectionTextColor'} size={25} />
            <Paragraph
              marginLeft={5}
              fontWeight={'500'}
              color={'$commentSectionTextColor'}
              fontSize={14}
            >
              {' '}
              {t('page.share')}{' '}
            </Paragraph>
          </XStack>
        </XStack>
        <Stack borderTopColor={'#D9D9D9'} borderTopWidth={1}></Stack>
      </View>
    );
  };

  const renderItem = ({ item, index }: { item: any; index: number }) => {
    const thumbnailPath =
      item?.thumbnailPath && item?.thumbnailPath.startsWith('http')
        ? item?.thumbnailPath
        : `${streamUrl}${item?.thumbnailPath}`;
    switch (item?.type) {
      case 'BANNER_AD':
        return (
          <BannerAds
            deviceWidth={deviceWidth}
            itemKey={item?.actionData?.content?.itemKey ?? index.toString()}
            unitId={item?.actionData?.content?.unitId}
            adSizeDefs={item?.actionData?.content?.adSizeDefs ?? []}
            bannerAdKeywords={bannerAdKeywords}
            screenName={
              itemId
                ? 'notification clicked video'
                : isRecommendedRef?.current
                  ? 'feed recommended video'
                  : 'feed video'
            }
          />
        );
      default:
        return (
          <Pressable onPress={() => switchToRecommendList(index)}>
            <XStack height={210} margin={10} flex={1}>
              <LinearGradient
                colors={['$linearGradientColor1', '$linearGradientColor2']}
                start={[0, 1]}
                end={[0, 0.6]}
                zIndex={999}
                backgroundColor="$textDark"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: 10,
                  height: '100%',
                }}
              >
                <Image
                  height={210}
                  zIndex={-1}
                  borderRadius={10}
                  source={{ uri: `${thumbnailPath}` }}
                  resizeMode="cover"
                />
                <View style={{ position: 'absolute', top: '35%', left: '40%' }}>
                  <VideoPlayIconRegular size={50} color={'$background'} />
                </View>
                <YStack
                  gap={5}
                  style={{
                    padding: 10,
                    width: '100%',
                    height: 210,
                    justifyContent: 'flex-end',
                    position: 'absolute',
                    bottom: 5,
                  }}
                >
                  <XStack marginRight={20}>
                    <Eye
                      fontSize={14}
                      size={20}
                      fontWeight={'400'}
                      color={'$viewsCountColor'}
                      position="relative"
                      top={2}
                    />
                    <Paragraph
                      fontSize={14}
                      fontWeight={'400'}
                      color={'$viewsCountColor'}
                      paddingLeft={3}
                    >
                      {item?.views} {t('page.views')}
                    </Paragraph>
                  </XStack>

                  <Text
                    numberOfLines={1}
                    ellipsizeMode="tail"
                    style={{ color: '#FFFFFF', fontSize: 16, fontWeight: '600' }}
                  >
                    {item?.description}
                  </Text>
                  <Text
                    numberOfLines={1}
                    style={{
                      color: '#FFFFFF',
                      fontSize: 16,
                      fontWeight: '400',
                      lineHeight: 18,
                      paddingTop: 4,
                    }}
                  >
                    {item?.account?.displayName}
                    {item?.description}
                    {item?.views} {t('page.views')}
                  </Text>
                </YStack>
              </LinearGradient>
            </XStack>
          </Pressable>
        );
    }
  };

  const renderFlashListItem = ({ item, index }: { item: any; index: number }) => {
    if (index === 0) {
      return null;
    }
    return renderItem({ item, index });
  };

  const handleBackButtonClick = () => {
    // Implement back button functionality here
    back();
  };

  const handleEndReached = async () => {
    await getRecommendedVideos(currentPlayingVideo);
  };

  return (
    <View
      key={currentLongVideoSelected?.actionData?.content?.id}
      style={{
        flex: 1,
        marginTop: isFullScreen ? 0 : StatusBar.currentHeight,
        // backgroundColor: 'black',
      }}
    >
      <View style={{ flex: 1 }} backgroundColor={'$cardbackground'}>
        <View style={{ flex: 1.5 }}>
          <NKPlayer
            style={{
              height: isFullScreen ? '100%' : '70%',
              width: '100%',
            }}
            ref={playerRef}
            source={source}
            config={config}
            playList={playlist}
            insets={edgeinsets}
            theme={{
              fonts: {
                primaryFont: 'Montserrat-Medium',
                secondaryFont: 'Montserrat-Regular',
              },
            }}
            // onPlay={onPlay}
            onPause={onPaused}
            onSkipNext={onSkipNext}
            onSkipBack={onSkipBack}
            onBackPress={onBackPress}
            // onFullScreenModeUpdate={onFullScreenModeUpdate}
            onToggleFullScreen={onToggleFullScreen}
            onPlayProgress={onProgress}
            onPlaybackStateProgress={onPlaybackStateChanged}
            onLoad={onLoad}
            // repeat={false}
            onEnd={onEnd}
            onLoadStart={onLoadStart}
            onReceiveAdEvent={onReceiveAdEvent}
            onAspectRatioPress={onAspectRatioPress}
            onError={(e: string) => {
              const videoErrorEvent: INinjaEvent = {
                name: KissanEventType.VIDEO_ERROR,
                screenDetails: {
                  screen: itemId
                    ? 'notification clicked video'
                    : isRecommendedRef?.current
                      ? 'feed recommended video'
                      : 'feed video',
                },
                eventParams: [addEventParam('errorMessage', e.toString())],
              };
              processEvents([videoErrorEvent]);
            }}
          />

          {!longStreamVideos && (
            <View>
              <Card
                shadowColor={'$overlaybg'}
                shadowRadius={5}
                elevation={5}
                marginHorizontal={5}
                shadowOpacity={0.2}
                marginVertical={10}
                backgroundColor="$cardbackground"
              >
                <Stack padding={10}>
                  <Placeholder Animation={Shine}>
                    <PlaceholderMedia
                      style={[{ width: '95%', height: 220, marginLeft: 10, marginTop: 10 }]}
                    />
                    <PlaceholderLine width={80} style={{ marginTop: 10 }} />
                    <PlaceholderLine width={80} />
                  </Placeholder>
                </Stack>
              </Card>
            </View>
          )}
        </View>
        {!isFullScreen && (
          <View style={{ flex: 3, marginTop: 10 }}>
            <FlashList
              data={longStreamVideos}
              renderItem={renderFlashListItem}
              keyExtractor={(item, index) => index.toString()}
              showsVerticalScrollIndicator={false}
              ItemSeparatorComponent={Separator}
              ListHeaderComponent={renderVideoLikeCommentSection}
              onEndReachedThreshold={0.8}
              onEndReached={handleEndReached}
            />
          </View>
        )}
        {commentbottomSheet && (
          <UIBottomSheet
            open={commentbottomSheet}
            animation={'quick'}
            onOpenChange={setCommentbottomSheet}
            snapPoints={[80]}
            children={
              feedItem && (
                <CommentSection
                  feedDetail={feedItem}
                  bottom={30}
                  threads={[]}
                  setCommentsCount={setCommentsCount}
                  commentsCount={commentsCount}
                  useKeyBoardHeight={true}
                  itemType={'STREAM'}
                  setCommentbottomSheet={setCommentbottomSheet}
                  commentbottomSheet={commentbottomSheet}
                />
              )
            }
          />
        )}
      </View>
    </View>
  );
};
